<template>
  <div id="app">
    <div class="marker" :style="{ 'backgroundImage': 'url(' + watermarks.bg1 + ')' }"></div>
    <div class="marker" :style="{ 'backgroundImage': 'url(' + watermarks.bg2 + ')' }"></div>
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
    <!--显示/隐藏提示信息 -->
    <div class="img_index" v-show="img_index">
      <div class="img_index_bg" @click="img_index = false">
        <a-button size="large" icon="close-circle" type='primary'></a-button>
      </div>
      <div class="img_index_text">为了保护信息安全，本页面禁止截图</div>
    </div>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import setWatermark from '@/assets/js/watermark.js'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      bg1: null,
      bg2: null,
      locale: zhCN,
      img_index: false
    };
  },
  computed: {
    ...mapState(['watermarks']),
    isMobile() {
      return document.body.clientWidth <= 720
    },
    nick() {
      return this.$store.state.user.uname
    }
  },
  created() {

  },
  watch: {
    nick(newVal) {
      this.$store.dispatch('updateWatermarks')
    },
  },
  mounted() {
    // 禁用右键菜单
    // document.addEventListener('contextmenu', this.preventContextMenu);
    // 禁用开发者工具快捷键，限制页面截图，需要时打开
    // document.addEventListener('keydown', this.preventDevTools);
    // document.addEventListener('keyup', this.releaseDevTools);
  },
  methods: {
    preventContextMenu(e) {
      e.preventDefault();
    },
    releaseDevTools(e) {
      if (e.keyCode === 18) {
        this.img_index = false
        e.preventDefault();
      }
    },
    preventDevTools(e) {
      if (e.altKey && e.keyCode === 18) {
        this.img_index = true
        e.preventDefault();
      }
      // 禁用F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C, Ctrl+U等
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
        (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
        (e.ctrlKey && e.keyCode === 83) || // Ctrl+S
        (e.metaKey && e.keyCode === 83) || // Cmd+S (Mac)
        (e.altKey && e.key === "a")
      ) {
        e.preventDefault();
      }
    },
    portMenu(tdata, Arr) {
      tdata.map((v, i) => {
        var newValue = v.perms + ":" + v.id;
        Arr.push({
          label: v.title,
          key: newValue
        });
        if (v.children && v.children.length > 0) {
          this.portMenu(v.children, Arr);
        }
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('contextmenu', this.preventContextMenu);
    document.removeEventListener('keydown', this.preventDevTools);
    document.removeEventListener('keyup', this.releaseDevTools);
  }
}
</script>

<style lang="less">
@import url("./assets/css/style.less");

.img_index {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #ffff;
  display: flex;
  align-items: center;
  justify-content: center;

  .img_index_text {
    font-size: 26px;
    text-align: center;
    color: #66707C;
  }

  .img_index_bg {
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 9999;
    top: 40px;
    right: 40px;
    // background: #000;
  }
}

#app {
  max-width: 100%;
  margin: 0 auto;


  .ant-btn-primary {
    background-color: #1d8bfe;
    border-color: #1d8bfe;
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: #40a9ff;
    border-color: #40a9ff;
  }

  .blu {
    border: 1px solid #1d8bfe;
    color: #1d8bfe;
  }

  // @import url("./assets/css/mobile.less");
}

.wbg {
  background: #fff;
  padding: 20px;
}

.curpoter {
  cursor: pointer;

  &:hover {
    div {
      color: #1d8bfe;
    }

    color: #1d8bfe;
  }
}

.marker {
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: fixed;
  z-index: 9999;
  background-position: top center;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>
